import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined'
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined'
import { useAppTheme } from '../../theme/ThemeContext'

type Props = {
  className?: string
}

const ThemeToggle = ({ className = '' }: Props) => {
  const { theme, toggleTheme } = useAppTheme()
  const isDark = theme === 'dark'
  const label = isDark ? 'Switch to light mode' : 'Switch to dark mode'

  return (
    <Tooltip title={label}>
      <IconButton
        onClick={toggleTheme}
        aria-label={label}
        aria-pressed={isDark}
        className={`theme-toggle ${className}`}
        size="small"
        sx={{ color: 'var(--text-primary)' }}
      >
        {isDark ? <LightModeOutlinedIcon fontSize="small" /> : <DarkModeOutlinedIcon fontSize="small" />}
      </IconButton>
    </Tooltip>
  )
}

export default ThemeToggle
